import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { ProjectsListPage } from "./pages/ProjectsListPage";
import { ProjectsEditPage } from "./pages/ProjectsEditPage";
import { ContactsListPage } from "./pages/ContactsListPage";
import { ContactsDetailPage } from "./pages/ContactsDetailPage";
import { LivePreviewEditor } from "./pages/LivePreviewEditor";
import { NewsEditorPage } from "./pages/NewsEditorPage";
import { JobsEditorPage } from "./pages/JobsEditorPage";
import { BpListPage } from "./pages/BpListPage";
import { BpDetailPage } from "./pages/BpDetailPage";
import { StudioUsersPage } from "./pages/StudioUsersPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { StudioSubmissionsPage } from "./pages/StudioSubmissionsPage";
import { StudioSubmissionDetailPage } from "./pages/StudioSubmissionDetailPage";
import { StudioReportsPage } from "./pages/StudioReportsPage";
import { StudioReportDetailPage } from "./pages/StudioReportDetailPage";
import { BackupPage } from "./pages/BackupPage";
import { MaintenancePage } from "./pages/MaintenancePage";
import { ProfilePage } from "./pages/ProfilePage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/projects" replace />} />

        {/* 列表类管理菜单 */}
        <Route path="/projects" element={<ProjectsListPage />} />
        <Route path="/projects/:slug" element={<ProjectsEditPage />} />
        <Route path="/studio/users" element={<StudioUsersPage />} />
        <Route path="/studio/users/:id" element={<UserDetailPage />} />
        <Route path="/studio/submissions" element={<StudioSubmissionsPage />} />
        <Route path="/studio/submissions/:id" element={<StudioSubmissionDetailPage />} />
        <Route path="/studio/reports" element={<StudioReportsPage />} />
        <Route path="/studio/reports/:id" element={<StudioReportDetailPage />} />
        <Route path="/backup" element={<BackupPage />} />
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/news" element={<NewsEditorPage />} />
        <Route path="/bp" element={<BpListPage />} />
        <Route path="/bp/:id" element={<BpDetailPage />} />
        <Route path="/jobs" element={<JobsEditorPage />} />
        <Route path="/contacts" element={<ContactsListPage />} />
        <Route path="/contacts/:id" element={<ContactsDetailPage />} />

        {/* 页面文案：单一入口。进去后在官网预览里左键切页面、右键改文字，
            覆盖首页/关于/投资/智库/BP/联系及品牌·导航·页脚等所有页面文案。 */}
        <Route path="/pages" element={
          <LivePreviewEditor route="home" title="页面文案"
            subtitle="在下方官网预览里：左键点导航/按钮照常切换页面，右键点任意文字即可编辑其中英文" />
        } />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
